import { Fragment, useRef, useState } from 'react';
import { FiChevronDown, FiSearch } from 'react-icons/fi';
import { LuListFilter } from 'react-icons/lu';
import NavbarSearch from './Navbar-Search';
import { Popover, Transition } from '@headlessui/react';
import NcmResult from './results/ncm';
import { api } from '../services/api';
import { LoadingDots } from './ui/loading';
import CClassTribResult from './results/CClassTribResult';

export default function EcoClass() {

  const [category, setCategory] = useState('products');
  const [query, setQuery] = useState('');

  const filterOptions = {
    products: ['NCM', 'cClassTrib', 'GTIN'],
    services: ['NBS', 'cClassTrib']
  }
  const [selectedFilter, setSelectedFilter] = useState('NCM');

  const inputRef = useRef(null);

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [canSearch, setCanSearch] = useState(false);

  async function handleSearch(e) {
    setResults([])
    e?.preventDefault();
    setSearched(true);
    setCanSearch(true);
    setLoading(true);
    try {
      let data;
      if (selectedFilter === 'NCM') {
        const response = await api.get(`siscomex/consulta/ncm`, {
          params: { ncm: query }
        });
        data = response.data;
      }
      else if (selectedFilter === 'GTIN') {
        const response = await api.get(`reforma/cclasstrib/bens/gtin`, {
          params: { gtin: query }
        });
        if (response.data?.cclass_trib === "Gtin nao consta na base da hotline") {
          data = null;
          return
        }
        data = response.data;
      }
      else if (selectedFilter === 'cClassTrib') {
        const response = await api.get(`reforma/bens/cclasstrib`, {
          params: { cclasstrib: query }
        });
        data = response.data;
      } else {
        console.warn('Filtro não implementado:', selectedFilter);
        data = null;
      }

      setResults(data ? [data] : []);
    }
    catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
    finally {
      setLoading(false);
    }
  }

  return (
    <>
      <NavbarSearch />
      <div className="flex-1 bg-gray-50 flex flex-col items-center py-10 px-4">
        <header className="w-full max-w-7xl mb-6">
          <h1 className="text-[#3d2d6b] text-2xl font-bold">Classificação Tributária</h1>
        </header>
        <div className="w-full max-w-7xl flex gap-2 bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="relative w-40">
            <select
              value={category}
              onChange={(e) => {
                setSelectedFilter(filterOptions[e.target.value][0]);
                setCategory(e.target.value);
                setResults([]);
              }}
              className="w-full border border-gray-300 rounded-md py-2 pl-3 pr-8 text-gray-700 appearance-none focus:outline-none"
            >
              <option value={"services"}>Serviços</option>
              <option value={"products"}>Bens (Produtos)</option>
            </select>
            <FiChevronDown className="absolute right-2 top-3 w-5 h-5 text-gray-500 pointer-events-none" />
          </div>
          <div className="flex-1 relative">
            <Popover className="relative w-full">
              {({ close }) => (
                <>
                  <div className="flex-1 relative">
                    <Popover.Button className="absolute left-2 top-1 p-2 bg-transparent rounded-md text-gray-500 hover:text-gray-700 focus:outline-none">
                      <LuListFilter className="w-5 h-5" />
                    </Popover.Button>
                    <form onSubmit={handleSearch}>
                      <input
                        type="text"
                        value={query}
                        ref={inputRef}
                        onChange={(e) => {
                          if (e?.target.value.length === 0) {
                            setSearched(false);
                          }
                          setQuery(e.target.value);
                        }}
                        placeholder={`Buscar por ${selectedFilter}...`}
                        className="w-full border border-gray-300 rounded-md py-2 pl-14 pr-10 focus:outline-none "
                      />
                    </form>
                    <button onClick={handleSearch} className="absolute right-2 top-1 p-2 bg-transparent text-gray-500 hover:text-gray-700">
                      <FiSearch className="w-5 h-5" />
                    </button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Popover.Panel className="absolute z-10 left-0 mt-2 w-56 origin-top-left bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="py-1">
                        {filterOptions[category].map((option) => (
                          <button
                            key={option}
                            onClick={() => {
                              setSelectedFilter(option);
                              close();
                              setResults([]);
                            }}
                            className={`w-full text-left block px-4 py-2 text-sm text-gray-700 ${option === selectedFilter ? 'bg-orange-50 text-orange-600' : ''} hover:bg-gray-100 hover:text-gray-900`}
                          >
                            {option}
                          </button>
                        ))}
                      </div>
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>
          </div>
        </div>

        {
          loading ?
            <div className="w-full max-w-5xl mt-12 bg-[#e9f3f3] rounded-lg p-10 text-center min-h-96 flex items-center justify-center">
              <LoadingDots />
            </div>
            : (!searched ?
              <div className="w-full max-w-5xl mt-12 bg-[#e9f3f3] rounded-lg p-10 text-center">
                <h3 className="text-[#3d2d6b] font-semibold mb-4">
                  Insira acima o código ou palavra-chave que deseja consultar
                </h3>
                <p className="text-gray-700 text-left max-w-2xl mx-auto">
                  <span className="font-medium">Para pesquisar:</span>
                  <ul className="list-disc ml-6 mt-2 text-sm">
                    <li>cClassTrib — digite os 4 dígitos do código</li>
                    <li>NCM — digite os 4 primeiros dígitos do código</li>
                    <li>GTIN — digite o código completo</li>
                  </ul>
                  <p className="mt-4 text-sm text-gray-600">
                    As informações sobre cCredPres, alíquotas e benefícios serão apresentadas na resposta da pesquisa.
                  </p>
                </p>
              </div>
              : results.length === 0
                ?
                <div className="w-full max-w-5xl mt-12 bg-[#e9f3f3] rounded-lg p-10 text-center">
                  <p className="text-gray-500">Nenhum resultado encontrado.</p>
                </div>
                : (
                  ['NCM', 'GTIN'].includes(selectedFilter) ? (
                    <NcmResult
                      type={selectedFilter}
                      result={results[0]}
                      codigo={query}
                      canSearch={canSearch}
                      setCanSearch={setCanSearch}
                    />
                  ) : selectedFilter === 'cClassTrib' ? (
                    <CClassTribResult
                      result={results[0]}
                    />
                  ) : (
                    <div className="w-full max-w-5xl mt-12 bg-[#e9f3f3] rounded-lg p-10 text-center">
                      <p className="text-gray-500">Tipo de filtro não suportado para renderização.</p>
                    </div>
                  )
                ))
        }
      </div>
    </>
  );
}